module.exports = __webpack_public_path__ + "static/media/abstract4.d73aa981.jpg";